<template>
  <div>
    <h3 class="text-h6 mb-4">Configuración de Textos y Leyendas</h3>
    
    <v-alert type="info" text dense class="mb-4">
      Personalice todos los textos que aparecen en el remito.
    </v-alert>

    <!-- Títulos -->
    <v-card class="mb-4">
      <v-card-title class="subtitle-1">
        <v-icon left>mdi-format-title</v-icon>
        Títulos de Secciones
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="textosInternos.titulos.cliente"
              label="Título Sección Cliente"
              outlined
              dense
              @input="emitirCambios"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="textosInternos.titulos.entrega"
              label="Título Sección Entrega"
              outlined
              dense
              @input="emitirCambios"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="textosInternos.titulos.solicitud"
              label="Título Sección Solicitud"
              outlined
              dense
              @input="emitirCambios"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="textosInternos.titulos.transporte"
              label="Título Sección Transporte"
              outlined
              dense
              @input="emitirCambios"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="textosInternos.titulos.detalle"
              label="Título Tabla Detalle"
              outlined
              dense
              @input="emitirCambios"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="textosInternos.titulos.observaciones"
              label="Título Observaciones"
              outlined
              dense
              @input="emitirCambios"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="textosInternos.titulos.condiciones"
              label="Título Condiciones"
              outlined
              dense
              @input="emitirCambios"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Leyendas -->
    <v-card class="mb-4">
      <v-card-title class="subtitle-1">
        <v-icon left>mdi-text-box</v-icon>
        Leyendas
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="textosInternos.leyendas.pieDocumento"
              label="Leyenda Pie de Documento"
              outlined
              dense
              rows="3"
              @input="emitirCambios"
            ></v-textarea>
          </v-col>
          <v-col cols="12" md="6">
            <v-textarea
              v-model="textosInternos.leyendas.tipoDocumento"
              label="Tipo de Documento"
              outlined
              dense
              rows="3"
              hint="Puede usar saltos de línea para texto en múltiples líneas"
              persistent-hint
              @input="emitirCambios"
            ></v-textarea>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="textosInternos.leyendas.original"
              label="Texto Original"
              outlined
              dense
              @input="emitirCambios"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Placeholders -->
    <v-card class="mb-4">
      <v-card-title class="subtitle-1">
        <v-icon left>mdi-text-box-outline</v-icon>
        Textos por Defecto
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="textosInternos.placeholders.sinObservaciones"
              label="Sin Observaciones"
              outlined
              dense
              @input="emitirCambios"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="textosInternos.placeholders.sinCondiciones"
              label="Sin Condiciones"
              outlined
              dense
              @input="emitirCambios"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'TextosEditor',
  
  props: {
    textos: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      textosInternos: {
        titulos: {
          cliente: 'Cliente',
          entrega: 'Entrega',
          solicitud: 'Solicitud de Entrega',
          transporte: 'Transportista',
          detalle: 'DETALLE',
          observaciones: 'OBSERVACIONES',
          condiciones: 'CONDICIONES DE ENTREGA'
        },
        leyendas: {
          pieDocumento: '',
          tipoDocumento: 'Documento no válido como factura',
          original: 'ORIGINAL'
        },
        placeholders: {
          sinObservaciones: 'Ninguna',
          sinCondiciones: 'Sin condiciones especiales'
        }
      }
    }
  },

  watch: {
    textos: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.textosInternos = JSON.parse(JSON.stringify(newVal))
        }
      }
    }
  },

  methods: {
    emitirCambios() {
      this.$emit('update', this.textosInternos)
    }
  }
}
</script>
